import { uploadToWasabi, describeWasabiError } from './wasabi';
import { savePendingUpload } from './offlineQueue';

// ── Singleton upload queue ────────────────────────────────────────────────────
// Each item: { id, filename, blob, userId, awb, status, progress, message }

let items = [];
let listeners = [];

const notify = () => listeners.forEach(fn => fn([...items]));

const update = (id, patch) => {
  items = items.map(item => item.id === id ? { ...item, ...patch } : item);
  notify();
};

export const subscribe = (fn) => {
  listeners.push(fn);
  fn([...items]);
  return () => { listeners = listeners.filter(l => l !== fn); };
};

export const dismissUpload = (id) => {
  items = items.filter(item => item.id !== id);
  notify();
};

export const enqueueUpload = (blob, filename, userId, awb) => {
  const id = crypto.randomUUID();
  items = [...items, { id, filename, blob, userId, awb, status: 'uploading', progress: 0, message: '' }];
  notify();
  runUpload(id, blob, filename, userId, awb);
  return id;
};

const runUpload = async (id, blob, filename, userId, awb) => {
  if (!navigator.onLine) {
    await savePendingUpload(id, blob, filename, userId, awb);
    update(id, { status: 'offline', message: 'Saved locally — will retry when online.' });
    return;
  }

  try {
    const { filename: finalFilename, isDuplicate } = await uploadToWasabi(
      blob,
      filename,
      (pct) => update(id, { progress: pct }),
      userId,
      awb,
    );
    const dupNote = isDuplicate ? ` (renamed → ${finalFilename})` : '';
    update(id, { status: 'success', progress: 100, message: `Uploaded: ${finalFilename}${dupNote}` });
  } catch (err) {
    console.error('[uploadQueue]', err);
    const reason = describeWasabiError(err);
    try {
      await savePendingUpload(id, blob, filename, userId, awb);
      update(id, { status: 'error', message: `Upload failed — saved locally for retry. ${reason}` });
    } catch {
      update(id, { status: 'error', message: `Upload failed. ${reason}` });
    }
  }
};